<template>
  <div>
    <ContentSectionLoader v-show="!loaded" />
    <Transition name="fade">
      <div v-show="loaded">
        <CommunicationCategoryList />
      </div>
    </Transition>
  </div>
</template>

<script type="text/babel">
import CommunicationCategoryList from
  'Communication/Resources/assets/js/components/communication-categories/CommunicationCategoryList'

export default {
  name: 'CommunicationCategories',
  components: {
    CommunicationCategoryList,
  },
  data() {
    return {
      loaded: true,
    }
  },
}
</script>
